import { use_component_is_mounted_300 } from '@/hooks/is_mounted/use_component_is_mounted_300';
import { DTO__entity_with_grid2d } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/DTO__entity_with_grid2d';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { DTO__grid2d_virtual } from '@shared/dto/grid2d_virtual/DTO__grid2d_virtual';
import { GRID2D_BUTTON__generation_reset_dimensions } from './GRID2D_BUTTON__generation_reset_dimensions';
import { GRID2D_BUTTON__generation_rotate } from './GRID2D_BUTTON__generation_rotate';
import { GRID2D_BUTTON__hide_sidebars } from './GRID2D_BUTTON__hide_sidebars';
import { GRID2D_BUTTON__show_as_gallery } from './GRID2D_BUTTON__show_as_gallery';
import { GRID2D_BUTTON__show_image_info } from './GRID2D_BUTTON__show_image_info';
import { GRID2D_BUTTON_change_cell_size } from './GRID2D_BUTTON_change_cell_size';
import { GRID2D_BUTTON_images_download } from './GRID2D_BUTTON_images_download';
import { GRID2D_BUTTON_images_sort } from './GRID2D_BUTTON_images_sort';
import { GRID2D_BUTTON_images_upload } from './GRID2D_BUTTON_images_upload';
import { GRID2D_BUTTON_scroll_to } from './GRID2D_BUTTON_scroll_to';

interface Props {
  entity: DTO__entity_with_grid2d;
  grid2d: DTO__grid2d;
  grid2d_virtual: DTO__grid2d_virtual;
  div_grid: HTMLDivElement;
}

export function GRID2D_BAR_buttons({ entity, grid2d, grid2d_virtual, div_grid }: Props) {
  const { is_mounted } = use_component_is_mounted_300();

  /*
   * HTML
   */
  return (
    <div
      className={`border border-component-border bg-bar flex justify-between space-x-1 px-2  rounded-lg hover-animation h-[30px]
         ${is_mounted ? 'opacity-100 scale-100' : 'opacity-0 scale-50'}`}
    >
      {/* todo: implement grid2d_chunk_on_screen */}
      <GRID2D_BUTTON__show_image_info {...{ grid2d }} />
      <GRID2D_BUTTON__generation_reset_dimensions {...{ grid2d, entity }} />
      <GRID2D_BUTTON_scroll_to {...{ grid2d_virtual, div_grid }} is_scroll_to_top />
      <GRID2D_BUTTON_scroll_to {...{ grid2d_virtual, div_grid }} is_scroll_to_top={false} />
      <GRID2D_BUTTON_images_sort {...{ grid2d, entity }} />
      <GRID2D_BUTTON_images_upload {...{ grid2d, entity }} />
      <GRID2D_BUTTON_images_download {...{ grid2d, entity }} />
      <GRID2D_BUTTON_change_cell_size />
      <GRID2D_BUTTON__hide_sidebars />
      <GRID2D_BUTTON__show_as_gallery />
      <GRID2D_BUTTON__generation_rotate {...{ grid2d, entity }} />
    </div>
  );
}
